import { getPayTypeList, getOrderStatusList, getPayStatusList, getFeeTypeList } from '@/request/api/base'

export default {
    //namespaced: true,
    state: {
        token: '',
        commonDict: [{
            value: '1',
            label: '上线',
        },
        {
            value: '2',
            label: '下线',
        }],                     // 通用字典
        apiMethodDict: [{
            value: 'GET',
            label: '查看(GET)',
        },
        {
            value: 'POST',
            label: '创建(POST)',
        },
        {
            value: 'PUT',
            label: '更新(PUT)',
        },
        {
            value: 'DELETE',
            label: '删除(DELETE)',
        }],                     // 请求方式字典

        payTypeDict: [],        // 支付方式字典
        orderStatusDict: [],    // 订单状态字典
        payStatusDict: [],      // 支付状态字典
        feeTypeDict: [],        // 计费类型字典
    },
    getters: {
    },
    mutations: {
        setPayTypeDict(state, data) {
            state.payTypeDict = data
        },
        setOrderStatusDict(state, data) {
            state.orderStatusDict = data
        },
        setPayStatusDict(state, data) {
            state.payStatusDict = data
        },
        setFeeTypeDict(state, data) {
            state.feeTypeDict = data
        },

    },
    actions: {

        async getPayTypeDict(state) {
            const { data: res } = await getPayTypeList()
            if (res.code == 0) {
                state.commit('setPayTypeDict', res.data.list)
            }
        },
        async getOrderStatusDict(state) {
            const { data: res } = await getOrderStatusList()
            if (res.code == 0) {
                state.commit('setOrderStatusDict', res.data.list)
            }
        },
        async getPayStatusDict(state) {
            const { data: res } = await getPayStatusList()
            if (res.code == 0) {
                state.commit('setPayStatusDict', res.data.list)
            }
        },
        async getFeeTypeDict(state) {
            const { data: res } = await getFeeTypeList()
            if (res.code == 0) {
                state.commit('setFeeTypeDict', res.data.list)
            }
        },
    }
}
